import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import Viewport from "@faire/web/common/Viewport";
import { computed } from "mobx";

import { BannersViewState } from "@faire/retailer/components/Banners/BannersViewState";
import { LoggedOutCategoryResultsBanner } from "@faire/retailer/components/Banners/LoggedOutCategoryBanners/LoggedOutCategoryResultsBanner";
import { IBannerData } from "@faire/retailer/lib/bannerUtils";

export class LoggedOutCategoryBannersViewState extends BannersViewState<LoggedOutCategoryResultsBanner> {
  constructor(private viewport: Viewport = Viewport.getDefault()) {
    super();
  }

  @computed
  get eligibleBannersDisplayDataInPriorityOrder(): IBannerData<LoggedOutCategoryResultsBanner>[] {
    const { filter_pill_banner, sign_up_product_grid_banner } =
      this.bannersResponse ?? {};

    const firstBannerRow =
      this.viewport.responsivelyReturnValue?.({
        mobileAndAbove: 4,
        tabletAndAbove: 3,
      }) ?? 3;

    const secondBannerRow =
      this.viewport.responsivelyReturnValue?.({
        mobileAndAbove: 8,
        tabletAndAbove: 6,
      }) ?? 6;

    return [
      sign_up_product_grid_banner
        ? {
            type: LoggedOutCategoryResultsBanner.SIGN_UP_PRODUCT_GRID_BANNER,
            size: 2,
            column: 1,
            row: firstBannerRow,
          }
        : undefined,
      filter_pill_banner
        ? {
            type: LoggedOutCategoryResultsBanner.FILTER_PILL_TILE,
            size: 1,
            column: 4,
            row: secondBannerRow,
          }
        : undefined,
    ].filter(isNotUndefined);
  }
}
